import { render } from "./ConfigurationTour.vue?vue&type=template&id=3fa90a10&ts=true"
import script from "./ConfigurationTour.vue?vue&type=script&lang=ts"
export * from "./ConfigurationTour.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__